<template>
  <div class="integration">
      <router-view />
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>